module.exports = __webpack_public_path__ + "img/33.052d3acc.png";